import React from 'react'
import { Observable } from 'rxjs'
import { AjaxResponse } from 'rxjs/ajax'
import { getReceivableAging } from 'utils/api-routes-accounts'
import ReportTablePage from './ReportTablePage'
import { useFinanceObservable } from '../../hooks/useFinanceObservable'
import { FinanceApiResponse } from '../../types/finance'

const ReceivableAging = () => {
  const report = useFinanceObservable<any[]>(
    () =>
      getReceivableAging({}) as any as Observable<
        AjaxResponse<FinanceApiResponse<any[]>>
      >,
  )

  return (
    <ReportTablePage
      title="Receivable Aging"
      isLoading={report.loading}
      rows={report.data || []}
      columns={[
        {
          name: 'Partner',
          selector: (row) => row.partner_name || row.name || '--',
        },
        { name: 'Current', selector: (row) => row.current ?? '--' },
        { name: '1-30', selector: (row) => row.bucket_1_30 ?? '--' },
        { name: '31-60', selector: (row) => row.bucket_31_60 ?? '--' },
        { name: '61-90', selector: (row) => row.bucket_61_90 ?? '--' },
        { name: '90+', selector: (row) => row.bucket_90_plus ?? '--' },
        { name: 'Total', selector: (row) => row.total ?? '--' },
      ]}
    />
  )
}

export default ReceivableAging
